import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Container from "react-bootstrap/Container";
import Figure from "react-bootstrap/Figure";
import '../../style/newsPage/newspage.scss';
import NewsImg from "../../assets/3 NIGHT.png"
import NewsImg2 from "../../assets/DSC02591.png"
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import NewsImg3 from "../../assets/IMG_5223.png"
import NewsImg4 from "../../assets/6.png"
import NewsImg5 from "../../assets/option 1-6.png";
import Image from "react-bootstrap/Image";
import Footer from "../work/footer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  newsview_title,
  newsview_fig_caption,
  news_subnav_content2,
  news_sidebar_title,
  news_subscribe_btn,
  news_updates_title,
  newsview_fig_caption_date,
} from "../../utility/constants";

function NewsView() {
  return (
    <div>
      <Container fluid className="news-view-div">
        <Row className=" gx-0">
          <Col lg={9}>
            <div style={{ display: "flex" }}>
              <div className="gx-0">
                <p className="news-latest-press-release-videos ">
                  {newsview_title}
                </p>

                <Col md={12}>
                  <Figure className="news-figure">
                    <Figure.Image
                      className="news-figure-img"
                      alt="News-IMG"
                      src={NewsImg}
                    />
                    <Figure.Caption className="news-figure-caption ">
                      {newsview_fig_caption}
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      {/* <br></br> */}
                      <h6>{newsview_fig_caption_date}</h6>
                    </Figure.Caption>
                  </Figure>
                </Col>

                <div className="news-figures-container">
                  <Row>
                    <Col lg={6} md={12}>
                      <Figure className="news-figure2">
                        <Figure.Image
                          className="news-figure-img2"
                          alt="News-IMG"
                          src={NewsImg2}
                        />
                        <Figure.Caption className="news-figure-caption2">
                          {newsview_fig_caption}
                          <br />
                          <br />
                          <h6>{newsview_fig_caption_date}</h6>
                        </Figure.Caption>
                      </Figure>
                    </Col>
                    <Col lg={6} md={12}>
                      <Figure className="news-figure2 ">
                        <Figure.Image
                          className="news-figure-img2"
                          alt="News-IMG"
                          src={NewsImg4}
                        />
                        <Figure.Caption className="news-figure-caption2">
                          {newsview_fig_caption}
                          <br />
                          <br />
                          <h6>{newsview_fig_caption_date}</h6>
                        </Figure.Caption>
                      </Figure>
                    </Col>
                  </Row>
                </div>

                <hr className="news-hr-line"></hr>

                <div className="news-video-div">
                  <p className="news-latest-press-release-videos">
                    {news_subnav_content2}
                  </p>
                  <Image src={NewsImg4} className="news-video" fluid />
                </div>
              </div>
            </div>
          </Col>
          <Col lg={3} className="news-sidebar-div">
            <p className="news-subscribe-to-news-letters">
              {news_sidebar_title}
            </p>

            <InputGroup className="mb-3">
              <Form.Control
                className="news-recipient-username"
                placeholder="Enter your email id"
                aria-label="Enter your email id"
                aria-describedby="basic-addon2"
              />
              <InputGroup.Text id="basic-addon2">
                {news_subscribe_btn}
              </InputGroup.Text>
            </InputGroup>
            <div>
              <p className="news-sidebar-updates">{news_updates_title}</p>
              <Figure className="news-figure3">
                <Figure.Image
                  className="news-figure-img3"
                  alt="News-IMG"
                  src={NewsImg3}
                />
                <Figure.Caption className="news-figure-caption3">
                  {newsview_fig_caption}
                  <br></br>
                  <br></br>
                  <h6>{newsview_fig_caption_date}</h6>
                </Figure.Caption>
              </Figure>

              <Figure className="news-figure3">
                <Figure.Image
                  className="news-figure-img3"
                  alt="News-IMG"
                  src={NewsImg5}
                />
                <Figure.Caption className="news-figure-caption3">
                  {newsview_fig_caption}
                  <br></br>
                  <br></br>
                  <h6>{newsview_fig_caption_date}</h6>
                </Figure.Caption>
              </Figure>
            </div>
          </Col>
        </Row>
        <Footer />
      </Container>
    </div>
  );
}

export default NewsView;
